import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Layout from "../Components/Layout/Layout";
import AddEventPackageModal from "../Components/CommanModals/AddEventPackageModal";
import DeleteModal from "../Components/CommanModals/DeleteModal";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { deleteEventPackage, eventPackagesListAction } from "../Redux/Actions/eventPackages";
import { capitalize } from "../Utils/commonFiles";

export default function EventPackages() {
  const dispatch = useDispatch();
  const packageList = useSelector((e) => e.eventPackageAuth.packageList);

  const [showModal, setShowModal] = useState(false);
  const [packageData, setPackageData] = useState({});
  const [packageToDelete, setPackageToDelete] = useState(null);

  useEffect(() => {
    dispatch(startstopLoading(true));
    dispatch(eventPackagesListAction({ page: 0, limit: 100 })).then(() => {
      dispatch(startstopLoading(false));
    });
  }, [dispatch]);

  const handleCreate = () => {
    setPackageData({});
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setPackageData(item);
    setShowModal(true);
  };

  const handleDelete = () => {
    dispatch(deleteEventPackage({ id: packageToDelete })).then((res) => {
      if (res?.payload?.statusCode === 200) {
        dispatch(eventPackagesListAction({ page: 0, limit: 100 }));
        toast.success("Deleted Successfully");
      } else {
        toast.error(res?.payload?.message);
      }
      setPackageToDelete(null);
    });
  };

  return (
    <Layout>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="comn-table-title">
              <h3>
                Event Packages <span>({packageList?.total || 0})</span>
              </h3>
              <button onClick={handleCreate}>Create New Package</button>
            </div>
            <div className="filters">
              <div className="inner-filter-field">
                <div className="table-responsive">
                  <Table size="sm" className="table-cmn">
                    <thead>
                      <tr>
                        <th>
                          <div className="user-checkbox">Package Name</div>
                        </th>
                        <th>
                          <div className="user-checkbox">Event Presets</div>
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {packageList?.packages?.map((item) => (
                        <tr key={item._id}>
                          <td>
                            <div className="first-user">
                              <div className="user-profile">{capitalize(item?.name)}</div>
                            </div>
                          </td>
                          <td>
                            <div className="first-user">
                              <div className="user-profile">
                                {item?.presets
                                  ?.map((p) => (p?.isDeleted ? `${p.eventType} (deleted)` : p?.eventType))
                                  .filter(Boolean)
                                  .join(", ")}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <div className="td-txt-bg" onClick={() => handleEdit(item)} style={{ cursor: "pointer" }}>Edit</div>
                              <div className="td-txt-bg" onClick={() => setPackageToDelete(item._id)} style={{ cursor: "pointer" }}>Delete</div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {!packageList?.packages?.length && (
                    <div className="song-requests-data">
                      <div className="no-data-found">
                        <p>No Data</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <AddEventPackageModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        packageData={packageData}
      />
      <DeleteModal
        show={!!packageToDelete}
        handleClose={() => setPackageToDelete(null)}
        handleDelete={handleDelete}
        name={"Package"}
      />
    </Layout>
  );
}
